import Header4 from 'elements/Header4';
import ds from 'designsystem';

const Header = Header4.extend`
  margin: 0;
  padding: ${ds.get('metrics.s')};
`;

export default Header;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ImageSlider/Header.jsx